import { useReportClock } from '../../reportClock';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { PlusCircle } from 'react-feather';
import { Link } from 'react-router-dom';
import { collection, getDocsFromServer } from 'firebase/firestore';
import { db, firebase_rdb } from '../../../../Config/Config';
import { Breadcrumbs } from '../../../../AbstractElements';
import CusClass from '../Common/CusClass';
import { mergeVisibleContracts } from '../contractData';
import i18n from '../../../../i18n';

const CLIENT_ID = 'maxpark-220731';
const CONTRACTS_PATH = `clients/${CLIENT_ID}/contrats`;
const CONTRACTS_COLLECTION = `clients/${CLIENT_ID}/contrats`;

const ContratsList = () => {
    const requestId = useRef(0);
    const reportNow = useReportClock();
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState('');

    const fetchData = async () => {
        const request = ++requestId.current;

        setFetchError('');

        const loadRealtimeContracts = async () => {
            const snapshot = await firebase_rdb.child(CONTRACTS_PATH).once('value');
            const contractsObj = snapshot.val() || {};

            return Object.keys(contractsObj).map((key) => ({
                ...contractsObj[key],
                id: key,
                source: 'realtime',
            }));
        };

        const loadFirestoreContracts = async () => {
            const querySnapshot = await getDocsFromServer(collection(db, CONTRACTS_COLLECTION));
            const contractsArray = [];

            querySnapshot.forEach((contractDoc) => {
                contractsArray.push({
                    ...contractDoc.data(),
                    id: contractDoc.id,
                    source: 'firestore',
                });
            });

            return contractsArray;
        };

        try {
            const [realtimeResult, firestoreResult] = await Promise.allSettled([
                loadRealtimeContracts(),
                loadFirestoreContracts(),
            ]);

            if (realtimeResult.status === 'rejected' && firestoreResult.status === 'rejected') {
                console.error('Error loading realtime contracts:', realtimeResult.reason);
                console.error('Error loading firestore contracts:', firestoreResult.reason);
                throw new Error('Unable to load contracts from Firebase.');
            }

            if (realtimeResult.status === 'rejected') {
                console.error('Error loading realtime contracts:', realtimeResult.reason);
            }

            if (firestoreResult.status === 'rejected') {
                console.error('Error loading firestore contracts:', firestoreResult.reason);
            }

            const realtimeContracts = realtimeResult.status === 'fulfilled' ? realtimeResult.value : [];
            const firestoreContracts = firestoreResult.status === 'fulfilled' ? firestoreResult.value : [];
            if (request !== requestId.current) return;
            setAllData(mergeVisibleContracts(realtimeContracts, firestoreContracts));
        } catch (error) {
            if (request !== requestId.current) return;
            console.error('Error loading contracts:', error);
            setFetchError('Impossible de charger les contrats.');
            setAllData([]);
        } finally {
            if (request === requestId.current) setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        return () => { requestId.current += 1; };
    }, [reportNow]);

    return (
        <Fragment>
            <Breadcrumbs parent={i18n.t('Dashboard_Breadcrumb_AllContracts')} title={i18n.t('Dashboard_Breadcrumb_ContractsList')} mainTitle={i18n.t('Dashboard_Breadcrumb_ContractsList')} />
            <Container fluid={true}>
                <Row>
                    <Col md="12" className="project-list">
                        <Card>
                            <Row>
                                <Col>
                                    <div className="text-end">
                                        <Link className="btn btn-primary" style={{ color: 'white' }} to={`${process.env.PUBLIC_URL}/dashboard/contracts/add`}>
                                            <PlusCircle /> {i18n.t('Dashboard_Contracts_New')}
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {loading && <p className="mb-0">{i18n.t('Dashboard_Contracts_Loading')}</p>}
                                {!loading && fetchError && <p className="mb-0 text-danger">{fetchError}</p>}
                                {!loading && !fetchError && allData.length === 0 && (
                                    <p className="mb-0">{i18n.t('Dashboard_Contracts_Empty')}</p>
                                )}
                                {!loading && !fetchError && allData.length > 0 && (
                                    <Row>
                                        {allData.map((contract) => (
                                            <CusClass item={contract} key={contract.id} />
                                        ))}
                                    </Row>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default ContratsList;
